import Feature38 from './Feature38'
export default Feature38
